module.exports = __webpack_public_path__ + "static/integration/d2l/img/ally-icon-indicator-medium.a662f4a26fd5fafb0774e99f9410f9e7.svg";